/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cx } from "@panda/css";

export interface IFrameProps {
	iframeSrc?: string | null;
	className?: string;
	title?: string | null;
}

export const IFrame = ({ className, iframeSrc, title }: IFrameProps): React.JSX.Element | null => {
	if (!iframeSrc) return null;
	const iframeHost = iframeSrc ? new URL(iframeSrc).hostname : "";
	const fallbackTitle = iframeHost ? `Embedded content from ${iframeHost}` : "Embedded content";

	return (
		<iframe
			className={cx(
				css({
					width: "100%",
					height: "100%",
				}),
				className,
			)}
			src={iframeSrc}
			title={title || fallbackTitle}
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerPolicy="strict-origin-when-cross-origin"
			allowFullScreen
		/>
	);
};
